// custom scripts
// mcs / 2016

// WINDOW SCROLLED
$(window).scroll(function() {    
  var scroll = $(window).scrollTop();
  if (scroll >= 200) {
      $("body").addClass("scrolled");
  } else {
      $("body").removeClass("scrolled");
  }
  if (scroll >= 20) {
      $("body").addClass("first-scrolled");
  } else {
      $("body").removeClass("first-scrolled");
  }
  

  
});

$(document).ready(function() {

  //console.log( "ready!" );
  $('body').addClass('ready');
  setTimeout(function(){
    $('body').addClass('ready2');
  }, 1000);
  setTimeout(function(){
    $('body').addClass('ready3');
  }, 3000);

  


  //collections filters
  $('.mcs-filters a').click(function() {
    var thefilter = $(this).data('handle');
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    console.log(thefilter);
    $('.mcs-handle-'+thefilter+'').siblings().hide();
    $('.mcs-handle-'+thefilter+'').show();
  });
  $('.mcs-filters a.all').click(function() {
    $('.mcs-handle-all-products').show();
  });  

  // position buttons for xl marketing
  $('.pos1').show();

  $('.pos-btn1').click(function() {
    $('.pos2').hide();
    $('.pos3').hide();
    $('.pos4').hide();
    $('.pos1').show();
  });
  $('.pos-btn2').click(function() {
    $('.pos1').hide();
    $('.pos3').hide();
    $('.pos4').hide();
    $('.pos2').show();
  });
  $('.pos-btn3').click(function() {
    $('.pos2').hide();
    $('.pos1').hide();
    $('.pos4').hide();
    $('.pos3').show();
  });
  $('.pos-btn4').click(function() {
    $('.pos2').hide();
    $('.pos3').hide();
    $('.pos1').hide();
    $('.pos4').show();
  });



  // percent discount switcher 
  //$('.percent-discount-wrap').children().hide();
  $('.variant-selector-1').click(function() {
    $('.percent-discount-wrap').children().hide();
    $('.percent-discount-wrap').children('.variant-selector-1').show();
  });
  $('.variant-selector-2').click(function() {
    $('.percent-discount-wrap').children().hide();
    $('.percent-discount-wrap').children('.variant-selector-2').show();
  });
  $('.variant-selector-3').click(function() {
    $('.percent-discount-wrap').children().hide();
    $('.percent-discount-wrap').children('.variant-selector-3').show();
  });
  $('.variant-selector-4').click(function() {
    $('.percent-discount-wrap').children().hide();
    $('.percent-discount-wrap').children('.variant-selector-4').show();
  });



  $('.non-swatch-selector').click(function() {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
  });




  $('.products-btn').click(function() {
    $(this).toggleClass('active');
    // $('.header-products').toggleClass('active');

    $('.header-products-new').toggleClass('active');
  });

  

  $('.m-tab').click(function() {
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    var curr_tab = $(this).attr('data-tab');
    console.log(curr_tab);
    $('.mtabs-stage').find('#' + curr_tab).siblings().hide();
    $('.mtabs-stage').find('#' + curr_tab).show();
  });





  $('.countries-dropdown li').click(function() {
    var country = $(this).attr('data-country');
    var countrynew = country.replace(/\s+/g, '');
    console.log(country); 
    
    // wack stuff to make it say 'United States' instead of usa
    if (country == 'usa') {
      $('#active-country').removeClass().addClass(countrynew).html( '<span>'+ 'United States' + '</span><span class="country-img"></span><b class="caret"></b>' );
    } else {
      $('#active-country').removeClass().addClass(countrynew).html( '<span>'+ country + '</span><span class="country-img"></span><b class="caret"></b>' );
    }
    
    // var countrynew = country.replace(/\s+/g, '');
    // console.log(countrynew); 
    // var img_src = '/images/'+ countrynew +'.png';
    // $('#active-country-img').attr('src', img_src);
  });

  // link to specific country from hash
  function switchCountry() {
    if (window.location.hash) {
      var url = document.location.toString();
      console.log(url);

      $('where-to-buy-section').addClass('not-ready');

      // set current country according to hash
      var country = url.split('#')[1];
      console.log(country);

      // make current country top of dropdown
      var countrynew = country.replace(/\s+/g, ''); // not sure if this is necessary
      if (country == 'usa') { // wack stuff to make it say 'United States' instead of usa
        $('#active-country').removeClass().addClass(countrynew).html( '<span>'+ 'United States' + '</span><span class="country-img"></span><b class="caret"></b>' );
      } else {
        $('#active-country').removeClass().addClass(countrynew).html( '<span>'+ country + '</span><span class="country-img"></span><b class="caret"></b>' );
      }

      // set the active bootstrap tab
      $('.elab-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');

      // top
      $("html, body").animate({ scrollTop: 0 }, 0);  

    }
  }
  
  
  $('.flag-link').click(function() {
	  location.reload();
    //$('html,body').scrollTop(0);  

    $("html, body").animate({ scrollTop: 0 }, 0);
  });

  //switchCountry();
  $(window).load(function() {
    switchCountry();
  });





  setInterval(function time(){
    var d = new Date();
    var hours = 24 - d.getHours();
    var min = 60 - d.getMinutes();
    if((min + '').length == 1){
      min = '0' + min;
    }
    var sec = 60 - d.getSeconds();
    if((sec + '').length == 1){
          sec = '0' + sec;
    }
    jQuery('#the-final-countdown').html(hours+':'+min+':'+sec)
  }, 1000);



  $('#contactFormSubmit1').click(function(){ event.preventDefault(); if($('#contactFormName2').val()=='' && $('#contactFormName1').val()!=''){ $('#contactFormName1').attr('name','contact[name]'); $('#contactFormName2').attr('name','contact[name2]'); } if($('#contactFormEmail2').val()=='' && $('#contactFormEmail1').val()!=''){ $('#contactFormEmail1').attr('name','contact[email]'); $('#contactFormEmail2').attr('name','contact[email2]'); } if($('#contactFormMessage2').val()=='' && $('#contactFormEmail1').val()!=''){ $('#contactFormMessage1').attr('name','contact[body]'); $('#contactFormMessage2').attr('name','contact[body2]'); } $('#contactFormSubmit').trigger('click'); }); 


  function yesnoCheck(that) {
    if (that.value == "other") {
        alert("check");
        document.getElementById("ifYes").style.display = "block";
    } else {
        document.getElementById("ifYes").style.display = "none";
    }
  }


//   $('.swatch .swatch-element').click(function() {
//     $(this).siblings().removeClass('active-swatch');
//     $(this).addClass('active-swatch');
//   });
  
  
  
  // weird type.js error
  (function($){ // jQuery code here 
  $("#type").typed({
        strings: ["travel.", "hiking.", "spelunking.", "snowboarding.","jet-setting.","trade shows.", "your gym bag.", "field trips.", "hitchhiking.", "weekend getaways.",  "music festivals.", "beach parties." ],
  typeSpeed: 100,
  stringstops: [41, 41, 41, 41, 41, 41, 41],
  cursorChar: "",
  backDelay: 1000,
  showCursor: false,
  loop: true,
  contentType: 'html', // or text
  // defaults to false for infinite loop
  loopCount: false,
      });
  })(jQuery);


  
  // add visible to waypoints in viewport
  var viewport = $(window),
    setVisible = function (e) {
        var viewportTop = viewport.scrollTop() - 60, // add buffer to sotp area
            viewportBottom = viewport.scrollTop() + viewport.height() - 60 ;
        $('.waypoint').each(function () {
            var self = $(this),
                top = self.offset().top,
                bottom = top + self.height(),
                topOnScreen = top >= viewportTop && top <= viewportBottom,
                bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
                elemVisible = topOnScreen || bottomOnScreen;
            	self.toggleClass('visible', elemVisible);     
        });
    };
  viewport.scroll(setVisible);
  setVisible();
  


  // SCROLL TO FUNCTION
  $(function() {
    $('[data-toggle="elementscroll"]').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 120
          }, 1000);
          return false;
        }
      }
    });
  });
  

  $('#dock5video').on('ended',function(){
    //console.log('Video has ended!');
    $(this).addClass('already-played');
  });


  $('#dock5video-replay').click(function() {
    $('#dock5video')[0].play();
  });




  // cord dock
  $('#corddock-undock').click(function() {
    $('#corddock-loop').hide();
    $('#corddock-takecord-video').hide();
    $('#corddock-undock-video').show();
    $('#corddock-undock-video')[0].play();
  });
  $('#corddock-takecord').click(function() {
    $('#corddock-loop').hide();
    $('#corddock-undock-video').hide();
    $('#corddock-takecord-video').show();
    $('#corddock-takecord-video')[0].play();
  });



  // anchor pro

  $('.hangswitch-capture').on('click', function(e) {
    $(this).toggleClass("pressed"); //you can list several class names 
    $('.hang2').toggleClass("active"); //you can list several class names 
    e.preventDefault();
  });


  // $('.hang-switcher').click(function() {
  //   $('.hang2').removeClass( "pause" );
  // });



  $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav'
  });

  $('.slider-nav').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots: true,
  centerMode: true,
  focusOnSelect: true,
  variableWidth: true
  });



  // nightpad banner
  $('.toggle-light').click(function() {
    $(this).toggleClass('active');
    $('.zzz').toggleClass('active');
    $('.nightpad-banner1').toggleClass('active');
    $('.nightpad-banner2').toggleClass('active');
    $('.nightpad-slider-text').toggleClass('active');
  });



}); // clode doc ready


// stuff loaded later
$( window ).load(function() {

  setTimeout(function(){
    $('#prod-thumbs').addClass('ready');
  }, 1000);

  $('.overlay-site').fadeOut(500);
  
  $('.elab-new-slider').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    pageDots: true,
    prevNextButtons: true
  });

  $('.gostand-slider').flickity({
    contain: true,
    autoPlay: 2500,
    wrapAround: true,
    prevNextButtons: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    }
  });

  

});


